import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    data: [],
    pending: false
  },
  mutations: {
    setData(state, payload) {
      Vue.set(state, 'data', payload);
    },
    setPending(state, payload) {
      Vue.set(state, 'pending', payload);
    }
  },
  getters: {
    data(state) {
      return state.data;
    },
    dataWithItemEmpty(state) {
      return [{id: null, name: '-'}, ...state.data]
    },
    getById: state => (id, attribute = 'name', isReturnObject = false) => {
      const item = state.data.find(item => item.id === +id);

      if (!item) {
        return isReturnObject ? {} : '';
      }

      return isReturnObject ? item : item[attribute];
    }
  },
  actions: {
    fetch({state, commit}) {
      return new Promise((resolve) => {
        if (!state.pending && !state.data.length) {
          commit('setPending', true);
          commit('setData', [
            {id: 0, name: 'No'},
            {id: 1, name: 'Yes'}
          ]);
          commit('setPending', false);
          resolve();
        } else {
          resolve();
        }
      })
    }

  }
};
